"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toIskCurrencyString = void 0;
var toIskCurrencyString = function (input, showCurrencySymbol) {
    if (showCurrencySymbol === void 0) { showCurrencySymbol = false; }
    var currencySymbol = showCurrencySymbol ? ' kr.' : '';
    var formattedAmount = input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return formattedAmount + currencySymbol;
};
exports.toIskCurrencyString = toIskCurrencyString;
//# sourceMappingURL=Currency.js.map